(function () {
  function money(cents) {
    var val = Math.round(cents / 100);
    return '₹' + val.toLocaleString('en-IN');
  }

  function init() {
    var pdp = document.getElementById('pdp');
    if (!pdp) return;

    var jsonEl = pdp.parentElement.querySelector('script[id^="ProductJson-"]') || document.querySelector('script[id^="ProductJson-"]');
    var product = null;
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    var truePricesEl = document.getElementById('TruePrices-' + product.id);
    var truePrices = {};
    if (truePricesEl) { try { truePrices = JSON.parse(truePricesEl.textContent); } catch (e) {} }

    /* ---- Gallery ---- */
    var mainImgs = document.querySelectorAll('.pdp-main-img-el');
    var thumbs = document.querySelectorAll('.pdp-thumb');
    var dots = document.querySelectorAll('.pdp-img-dot');

    function showMedia(index) {
      mainImgs.forEach(function (img) {
        var match = img.dataset.mediaIndex === String(index);
        img.style.display = match ? '' : 'none';
        img.classList.toggle('active', match);
      });
      thumbs.forEach(function (t) { t.classList.toggle('active', t.dataset.mediaIndex === String(index)); });
      dots.forEach(function (d) { d.classList.toggle('active', d.dataset.mediaIndex === String(index)); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showMedia(t.dataset.mediaIndex); }); });
    dots.forEach(function (d) { d.addEventListener('click', function () { showMedia(d.dataset.mediaIndex); }); });

    /* ---- Qty stepper ---- */
    var qtyEl = document.getElementById('qty-num');
    var addBtn = document.getElementById('pdp-add');
    var mobileAddBtn = document.getElementById('pdp-mobile-add');

    function syncQty() {
      var q = qtyEl.value;
      if (addBtn) addBtn.dataset.qty = q;
      if (mobileAddBtn) mobileAddBtn.dataset.qty = q;
    }
    var qtyMinus = document.getElementById('qty-minus');
    var qtyPlus = document.getElementById('qty-plus');
    if (qtyMinus) qtyMinus.addEventListener('click', function () { qtyEl.value = Math.max(1, parseInt(qtyEl.value, 10) - 1); syncQty(); });
    if (qtyPlus) qtyPlus.addEventListener('click', function () { qtyEl.value = Math.min(99, parseInt(qtyEl.value, 10) + 1); syncQty(); });

    /* ---- Bulk quantity tiers (informational estimate, real checkout price is the product's Shopify price) ---- */
    var tiersWrap = document.getElementById('pdp-tiers');
    var tierTotalEl = document.getElementById('pdp-tier-total');
    function updateTierTotal() {
      if (!tiersWrap || !tierTotalEl) return;
      var active = tiersWrap.querySelector('.pdp-tier.active');
      if (!active) return;
      var price = parseInt(active.dataset.price, 10) || 0;
      var qty = parseInt(qtyEl.value, 10) || 1;
      tierTotalEl.textContent = '₹' + (price * qty).toLocaleString('en-IN') + ' for ' + qty + ' pcs';
    }
    if (tiersWrap) {
      tiersWrap.addEventListener('click', function (e) {
        var btn = e.target.closest('.pdp-tier');
        if (!btn) return;
        tiersWrap.querySelectorAll('.pdp-tier').forEach(function (t) { t.classList.remove('active'); });
        btn.classList.add('active');
        var min = parseInt(btn.dataset.qtyMin, 10);
        if (min && (parseInt(qtyEl.value, 10) || 0) < min) { qtyEl.value = min; syncQty(); }
        updateTierTotal();
      });
      qtyEl.addEventListener('input', updateTierTotal);
      if (qtyMinus) qtyMinus.addEventListener('click', updateTierTotal);
      if (qtyPlus) qtyPlus.addEventListener('click', updateTierTotal);
      updateTierTotal();
    }

    /* ---- Option / variant matching ---- */
    var optionGroups = document.querySelectorAll('.pdp-opt-group');
    function currentSelection() {
      var sel = [];
      optionGroups.forEach(function (group) {
        var idxAttr = group.dataset.optionIndex;
        if (idxAttr === undefined) return;
        var idx = parseInt(idxAttr, 10);
        if (isNaN(idx)) return;
        var active = group.querySelector('.pdp-opt-btn.active');
        sel[idx] = active ? active.dataset.value : null;
      });
      return sel;
    }
    function findVariant(selection) {
      return product.variants.find(function (v) {
        return selection.every(function (val, i) { return val === null || v.options[i] === val; });
      });
    }

    var qtyOptionIndex = -1;
    if (product.options) {
      product.options.forEach(function (name, i) {
        if (/quantity/i.test(name)) qtyOptionIndex = i;
      });
    }
    function parsePieces(optionValue) {
      var m = /^(\d+)\s*Piece/i.exec(optionValue || '');
      return m ? parseInt(m[1], 10) : null;
    }
    function moqLabel(variant) {
      if (qtyOptionIndex === -1) return null;
      var candidates = product.variants.filter(function (v) {
        return v.available && v.options.every(function (val, i) { return i === qtyOptionIndex || val === variant.options[i]; });
      });
      var pieceCounts = candidates.map(function (v) { return parsePieces(v.options[qtyOptionIndex]); }).filter(Boolean);
      if (!pieceCounts.length) return null;
      return 'Minimum Order Quantity: ' + Math.min.apply(null, pieceCounts) + ' pcs';
    }
    function applyVariant(variant) {
      if (!variant) return;
      var priceEl = document.getElementById('pdp-price');
      var mrpEl = document.getElementById('pdp-mrp');
      var saveEl = document.getElementById('pdp-save');
      var stockEl = document.getElementById('pdp-stock-label');
      var mobilePriceEl = document.getElementById('pdp-mobile-price');

      var truePrice = truePrices[String(variant.id)] || 0;
      var hasDepositPlan = truePrice > 0;
      if (priceEl) priceEl.textContent = hasDepositPlan ? money(truePrice) : money(variant.price);
      if (mobilePriceEl) mobilePriceEl.textContent = money(variant.price);
      var savePct = 0;
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        savePct = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
      }
      if (mrpEl && saveEl) {
        if (savePct > 0) {
          mrpEl.textContent = money(variant.compare_at_price);
          saveEl.textContent = 'Save ' + savePct + '%';
          mrpEl.style.display = '';
          saveEl.style.display = '';
        } else {
          mrpEl.style.display = 'none';
          saveEl.style.display = 'none';
        }
      }
      var unavailableLabel = variant.available ? null : (moqLabel(variant) || 'Sold Out');

      if (stockEl) stockEl.textContent = variant.available ? 'In Stock' : unavailableLabel;

      [addBtn, mobileAddBtn].forEach(function (btn) {
        if (!btn) return;
        btn.dataset.variantId = variant.id;
        btn.disabled = !variant.available;
        btn.style.opacity = variant.available ? '' : '.5';
        btn.style.cursor = variant.available ? '' : 'not-allowed';
      });
      var availableLabel = hasDepositPlan ? ('Book the Order at Only ' + money(variant.price)) : 'Add to Order';
      var mobileAvailableLabel = hasDepositPlan ? ('Book at Only ' + money(variant.price)) : 'Add to Order';
      if (addBtn) {
        var svg = addBtn.querySelector('svg');
        addBtn.textContent = variant.available ? availableLabel : unavailableLabel;
        if (svg) addBtn.prepend(svg);
      }
      if (mobileAddBtn) mobileAddBtn.textContent = variant.available ? mobileAvailableLabel : unavailableLabel;

      if (variant.featured_media) {
        var idx = product.media.findIndex(function (m) { return m.id === variant.featured_media.id; });
        if (idx > -1) showMedia(idx);
      }

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    }

    optionGroups.forEach(function (group) {
      group.addEventListener('click', function (e) {
        var btn = e.target.closest('.pdp-opt-btn');
        if (!btn) return;
        group.querySelectorAll('.pdp-opt-btn').forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        var label = group.querySelector('.pdp-opt-selected');
        if (label) label.textContent = btn.dataset.value;
        var variant = findVariant(currentSelection());
        if (variant) applyVariant(variant);
      });
    });

    syncQty();

    /* ---- Accordion ---- */
    document.querySelectorAll('.pdp-acc-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.pdp-acc-item');
        var open = item.classList.contains('open');
        document.querySelectorAll('.pdp-acc-item').forEach(function (i) { i.classList.remove('open'); });
        if (!open) item.classList.add('open');
      });
    });

    initReviews();
  }

  function escapeHtml(s) {
    var d = document.createElement('div');
    d.textContent = s || '';
    return d.innerHTML;
  }

  function starString(rating) {
    var r = Math.round(rating);
    return '★'.repeat(r) + '☆'.repeat(5 - r);
  }

  function injectReviewSchema(section, data) {
    if (!data.count) return;
    var existing = document.getElementById('pdp-review-schema');
    if (existing) existing.remove();
    var schema = {
      '@context': 'https://schema.org',
      '@type': 'Product',
      name: section.dataset.productTitle,
      url: section.dataset.productUrl,
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: data.average,
        reviewCount: data.count,
      },
      review: data.reviews.slice(0, 10).map(function (r) {
        return {
          '@type': 'Review',
          author: { '@type': 'Person', name: r.author_name },
          datePublished: r.created_at.slice(0, 10),
          reviewRating: { '@type': 'Rating', ratingValue: r.rating },
          reviewBody: r.body,
          name: r.title || undefined,
        };
      }),
    };
    var script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'pdp-review-schema';
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);
  }

  function renderReviewSummary(data) {
    var summaryEl = document.getElementById('pdp-reviews-summary');
    if (!summaryEl) return;
    if (data.count > 0) {
      summaryEl.innerHTML = '<span class="stars">' + starString(data.average) + '</span> ' + data.average + ' out of 5 (' + data.count + ' review' + (data.count === 1 ? '' : 's') + ')';
    } else {
      summaryEl.textContent = 'No reviews yet — be the first to review this product.';
    }
  }

  function renderReviewList(data) {
    var listEl = document.getElementById('pdp-review-list');
    if (!listEl) return;
    if (!data.count) {
      listEl.innerHTML = '<p class="pdp-review-empty">No reviews yet. Be the first to share your experience with this product.</p>';
      return;
    }
    listEl.innerHTML = data.reviews.map(function (r) {
      var date = new Date(r.created_at);
      var dateStr = isNaN(date) ? '' : date.toLocaleDateString('en-IN', { year: 'numeric', month: 'short', day: 'numeric' });
      return '<div class="pdp-review-item">' +
        '<div class="pdp-review-item-head">' +
          '<span class="pdp-review-item-stars">' + starString(r.rating) + '</span>' +
          '<span class="pdp-review-item-author">' + escapeHtml(r.author_name) + '</span>' +
          '<span class="pdp-review-item-date">' + dateStr + '</span>' +
        '</div>' +
        (r.title ? '<div class="pdp-review-item-title">' + escapeHtml(r.title) + '</div>' : '') +
        '<div class="pdp-review-item-body">' + escapeHtml(r.body) + '</div>' +
        '</div>';
    }).join('');
  }

  function initReviews() {
    var section = document.getElementById('pdp-reviews');
    if (!section) return;
    var api = section.dataset.reviewsApi;
    var handle = section.dataset.productHandle;
    var form = document.getElementById('pdp-review-form');
    var openBtn = document.getElementById('pdp-review-open-form');
    var starPicker = document.getElementById('pdp-star-picker');
    var statusEl = document.getElementById('pdp-review-status');
    var selectedRating = 0;

    function loadReviews() {
      fetch(api + '/reviews?product=' + encodeURIComponent(handle))
        .then(function (res) { return res.ok ? res.json() : Promise.reject(res.status); })
        .then(function (data) {
          renderReviewSummary(data);
          renderReviewList(data);
          injectReviewSchema(section, data);
        })
        .catch(function () {
          var listEl = document.getElementById('pdp-review-list');
          if (listEl) listEl.innerHTML = '';
          var summaryEl = document.getElementById('pdp-reviews-summary');
          if (summaryEl) summaryEl.textContent = '';
        });
    }

    if (openBtn) {
      openBtn.addEventListener('click', function () {
        form.hidden = !form.hidden;
        openBtn.textContent = form.hidden ? 'Write a Review' : 'Cancel';
      });
    }

    if (starPicker) {
      starPicker.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function () {
          selectedRating = parseInt(btn.dataset.star, 10);
          starPicker.querySelectorAll('button').forEach(function (b) {
            b.classList.toggle('active', parseInt(b.dataset.star, 10) <= selectedRating);
          });
        });
      });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        statusEl.className = '';
        statusEl.textContent = '';

        if (!selectedRating) {
          statusEl.className = 'error';
          statusEl.textContent = 'Please select a star rating.';
          return;
        }
        var bodyVal = document.getElementById('pdp-review-body').value.trim();
        var nameVal = document.getElementById('pdp-review-name').value.trim();
        if (bodyVal.length < 10) {
          statusEl.className = 'error';
          statusEl.textContent = 'Please write a bit more detail (at least 10 characters).';
          return;
        }

        var submitBtn = document.getElementById('pdp-review-submit');
        submitBtn.disabled = true;
        statusEl.textContent = 'Submitting…';

        fetch(api + '/reviews', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            product_handle: handle,
            product_title: section.dataset.productTitle,
            rating: selectedRating,
            title: document.getElementById('pdp-review-title').value.trim(),
            body: bodyVal,
            author_name: nameVal,
            author_email: document.getElementById('pdp-review-email').value.trim(),
            hp: document.getElementById('pdp-review-hp').value,
          }),
        })
          .then(function (res) { return res.ok ? res.json() : res.json().then(function (d) { return Promise.reject(d); }); })
          .then(function () {
            statusEl.className = 'success';
            statusEl.textContent = 'Thanks! Your review is live.';
            form.reset();
            selectedRating = 0;
            starPicker.querySelectorAll('button').forEach(function (b) { b.classList.remove('active'); });
            loadReviews();
            setTimeout(function () { form.hidden = true; if (openBtn) openBtn.textContent = 'Write a Review'; }, 1500);
          })
          .catch(function (err) {
            statusEl.className = 'error';
            statusEl.textContent = (err && err.error === 'rate_limited') ? 'Too many reviews submitted — please try again later.' : 'Something went wrong. Please try again.';
          })
          .finally(function () {
            submitBtn.disabled = false;
          });
      });
    }

    loadReviews();
  }

  document.addEventListener('DOMContentLoaded', init);
})();
